export default "__VITE_ASSET__CuA6uobM__"